import { render } from "./StudentDisciplineDataTable.vue?vue&type=template&id=1798a228&scoped=true"
import script from "./StudentDisciplineDataTable.vue?vue&type=script&lang=js"
export * from "./StudentDisciplineDataTable.vue?vue&type=script&lang=js"

import "./StudentDisciplineDataTable.vue?vue&type=style&index=0&id=1798a228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1798a228"]])

export default __exports__